import Image from "next/legacy/image";
import React, { useEffect } from "react";
import { BASE_URL } from "../../utils/FetchData"


export default function Amenity({ inView,amenity, projectPage, phasePage, commercialServices, phaseColor, businessProject }) {
    return (
        <div
            className={`amenity ${projectPage ? "projectPage" : ""}
             ${phasePage ? "phasePage" : ""}
             ${commercialServices ? "commercialServices-section" : ""}
             ${businessProject ? "businessProject" : ""}
             ${inView ? "in-view" : ""}
             ${!amenity?.Description ? "no-hover" : ""}
             `}
        >
            {phasePage ?
                <>
                    <div className="amenity-header">
                        <div className="icon-container">
                            {amenity?.Icon?.data?.attributes?.url && <Image
                                src={BASE_URL + amenity?.Icon?.data?.attributes?.url}
                                layout="fill"
                                objectFit="contain"
                                alt="icon"
                            />}
                        </div>
                        <h4 className="title">{amenity?.Text}</h4>
                    </div>
                    <div className="amenity-info">
                        <p className="desc">{amenity?.Description}</p>
                    </div>
                </>
                :
                <>
                    <div className="icon-container">
                        {amenity?.Icon?.data?.attributes?.url && <Image
                            src={BASE_URL + amenity?.Icon?.data?.attributes?.url}
                            layout="fill"
                            objectFit="contain"
                            alt="icon"
                        />}
                    </div>
                    <div className="amenity-info">
                        <h4 className="title">{amenity?.Text}</h4>
                        <p className="desc">{amenity?.Description}</p>
                    </div>
                </>
            }
            <div
                className={`back-layer`}
                style={{ backgroundColor: phasePage ? phaseColor : "#292c33" }}
            ></div>
        </div>
    );
}
